import '@aofl/drawer';

export default (ctx, html) => html`
  <aofl-drawer id="drawer" ?open="${ctx.ddActive}" opening="slide-down" closing="slide-up" trigger="animate">
    <div id="drawer-wrapper"><slot></slot></div>
  </aofl-drawer>
`;
